
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invalid-referral-code",
      function () {
        return require("private-next-pages/invalid-referral-code.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invalid-referral-code"])
      });
    }
  